import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'EcommStoreProductPageCarousel',
})(({ spacing, breakpoints, brandColors, typography }) => ({
  container: {
    width: '100%',
    justifyContent: 'center',
  },
  navigationButtonDisabled: {
    opacity: 0.3,
    cursor: 'default',
    '&:hover, &:focus': {
      backgroundColor: 'white',
    },
  },
  swiperSlide: {
    marginRight: 0,
    width: 'fit-content !important',
    [breakpoints.up('sm')]: {
      '&:not(:last-child)': {
        marginRight: spacing(2),
      },
    },
  },
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    gap: spacing(3),
    marginTop: spacing(2),
    cursor: 'pointer',
  },
  navigationButton: {
    display: 'none',
    cursor: 'pointer',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: typography.pxToRem(40),
    height: typography.pxToRem(40),
    borderRadius: typography.pxToRem(800),
    border: `${typography.pxToRem(1)} solid ${brandColors.primaryMain}`,
    color: brandColors.primaryMain,
    borderColor: brandColors.primaryMain,
    [breakpoints.up('sm')]: {
      display: 'flex',
      width: typography.pxToRem(60),
      height: typography.pxToRem(60),
    },
    '&:hover, &:focus': {
      backgroundColor: brandColors.interactiveHeroBlueSubtle,
    },
  },
  carousel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 40,
    marginTop: spacing(2),
  },
  carouselImage: {
    width: '100%',
    aspectRatio: '1/1',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: typography.pxToRem(16),
    [breakpoints.up('sm')]: {
      width: typography.pxToRem(182),
    },
    [breakpoints.up('md')]: { width: typography.pxToRem(150) },
    [breakpoints.up('lg')]: { width: typography.pxToRem(128) },
  },
  horizontal: {
    display: 'flex',
  },
  pagination: {
    width: 'fit-content!important',
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0),
    '& .bullet': {
      color: brandColors.tintsHeroBlue80,
    },
    '& .bullet-active': {
      color: brandColors.primaryMain,
    },
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: spacing(2),
    [breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  swiperContainer: {
    overflow: 'hidden',
  },
  hidden: { visibility: 'hidden' },
}));

export default useStyles;
